import { z } from 'zod';

export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/png', 'image/jpeg'] as const;

export const ALLOWED_UPLOAD_FOLDERS = ['documents'] as const;

export const uploadEncryptedValidator = z.object({
  folder: z.enum(ALLOWED_UPLOAD_FOLDERS),
  fileType: z.enum(ALLOWED_FILE_TYPES),
  fileBase64: z.string().base64('fileBase64 must be valid base64')
});

export type UploadEncryptedInput = z.infer<typeof uploadEncryptedValidator>;
